module.exports = __webpack_public_path__ + "img/drops_624.1417cad6.png";